<template>
  <div>
    <van-cell
      title="学员"
      is-link
      required
      @click="selectStudent"
    >
      <template>
        <div v-if="courseStudentParams.studentObj" style="color: var(--g8)">
          <div class="van-ellipsis" style="color: var(--g8)">
            <span>
              {{ courseStudentParams.studentObj.name }}
            </span>
          </div>
        </div>
        <div v-else style="color: var(--g5)">请选择</div>
      </template>
    </van-cell>
    <div class="course-box van-hairline--bottom">
      <van-cell title="课程" title-class="abc" required is-link @click="selectKc" :border="false" class="vc-class">
        <template>
          <div v-if="courseStudentParams.curriculumId" style="color: var(--g8)">
            {{ courseStudentParams.curriculumName }}
          </div>
          <div v-else style="color: var(--g5)">请选择</div>
        </template>
      </van-cell>
      <div
        v-if="courseStudentParams.curriculumId && classHoursMap[courseStudentParams.studentId] && classHoursMap[courseStudentParams.studentId].courseArrangeStat"
        class="van-tips">
        已排课：{{ classHoursMap[courseStudentParams.studentId].courseArrangeStat.count }}；<!--
        -->已点名：{{ classHoursMap[courseStudentParams.studentId].courseArrangeStat.signCount }}<!--
        --><span class="amount">剩余：<span
            :class="{ owe: classHoursMap[courseStudentParams.studentId].courseCard.classHourRemainTotalAmount <= 0 }">{{ classHoursMap[courseStudentParams.studentId].courseCard.classHourRemainTotalAmount >= 0 ? classHoursMap[courseStudentParams.studentId].courseCard.classHourRemainTotalAmount : 0 }}
            <template v-if="classHoursMap[courseStudentParams.studentId].courseCard.classHourRemainTotalAmount < 0">(欠费{{ Math.abs(classHoursMap[courseStudentParams.studentId].courseCard.classHourRemainTotalAmount) }})</template>{{ lessonUnit }}
          </span>
          <span 
            :class="{ owe: classHoursMap[courseStudentParams.studentId].courseCard.dayRemainTotalAmount <= 0 }"
            v-if="classHoursMap[courseStudentParams.studentId].courseCard.dayRemainTotalAmount !== 0">，{{ classHoursMap[courseStudentParams.studentId].courseCard.dayRemainTotalAmount >= 0 ? classHoursMap[courseStudentParams.studentId].courseCard.dayRemainTotalAmount : 0 }}<template 
            v-if="classHoursMap[courseStudentParams.studentId].courseCard.dayRemainTotalAmount < 0">(欠费{{ Math.abs(classHoursMap[courseStudentParams.studentId].courseCard.dayRemainTotalAmount) }})</template>天
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
let defaultParams = {
  curriculumId: '',
  curriculumName: '',
  studentId: '',
  studentObj: null,
}
export default({
  name: 'paike-student-first',
  props: {
    params: {},
    campusList: Array,
  },
  data(){
    return {
      courseStudentParams: {
        ...JSON.parse(JSON.stringify(defaultParams)),
      },
      classHoursMap: {}
    }
  },
  computed: {
    ...Vuex.mapState(['lessonUnit']),
  },
  methods: {
    // 选择学员
    async selectStudent() {
      let ret = await app.x3.side.xsStudent({
        id: this.courseStudentParams.studentId,
        params: {
          campusIds: [this.params.campusId],
          campusList: this.campusList,
          status: [1],
        },
        defaultParams: {
          status: [1],
        },
        config: {
          enableFilter: true,
          enableStudentStatus: true,
          enableStudentStatusIds: [1, 6, 7],
          enableClassFilter: true,
        },
      });
      if (!ret || ret.id != this.courseStudentParams.studentId) {
        this.courseStudentParams.curriculumId = '';
        this.courseStudentParams.curriculumName = '';
      }
      this.courseStudentParams.studentId = ret ? ret.id : '';
      this.courseStudentParams.studentObj = ret;
    },
    // 选择课程
    async selectKc() {
      if (!this.courseStudentParams.studentId) {
        return vant.Toast('请先选择学员');
      }
      let ret = await app.x3.side.xsCourse({
        id: this.courseStudentParams.curriculumId,
        api: this.$api.findCurriculumInfoByStudentId,
        params: {
          campusId: this.params.campusId,
          studentId: this.courseStudentParams.studentId,
          chargeTypeList: [1],
        },
        config: {
          radio: true,
        },
        filter: {
          enableChargeType: false,
        },
      });
      if (ret) {
        this.courseStudentParams.curriculumId = ret.id;
        this.courseStudentParams.curriculumName = ret.curriculumName;

        this.showLoading();
        const res = await this.$api.findStudentCurriculumCard({
          campusId: this.params.campusId,
          curriculumId: this.courseStudentParams.curriculumId,
          studentIds: [this.courseStudentParams.studentId],
        });
        vant.Toast.clear();
        const obj = {};
        res.data.forEach(item => {
          obj[item.studentId] = item;
        });
        this.classHoursMap = obj;
        console.log(obj);
      } else {
        this.courseStudentParams.curriculumId = '';
        this.courseStudentParams.curriculumName = '';
      }
    },
    resetCourseStudentInfos() { // 重置课程学员信息
      this.courseStudentParams = {
        ...JSON.parse(JSON.stringify(defaultParams)),
      };
    },
  },
  watch: {
    courseStudentParams: {
      deep: true,
      immediate: true,
      handler: function (nv, ov) {
        this.$emit('change', {
          curriculumId: this.courseStudentParams.curriculumId,
          curriculumName: this.courseStudentParams.curriculumName,
          studentIds: this.courseStudentParams.studentId?[this.courseStudentParams.studentId] : [],
          studentObjs: this.courseStudentParams.studentObj?[this.courseStudentParams.studentObj] : [],
        });
      },
    },
  }
})
</script>
<style lang="scss" scoped>
.course-box {
  background-color: var(--white);
  padding-bottom: calc(var(--gap) * 8);
  .vc-class {
    padding: calc(var(--gap) * 15) calc(var(--gap) * 16) calc(var(--gap) * 8)
          calc(var(--gap) * 16);
  }
  .van-tips {
    position: relative;
    text-align: right;
    padding: 0 calc(var(--gap) * 36) 0 calc(var(--gap) * 16);
    color: var(--g6);
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
    .owe {
      color: var(--c3) !important;
    }
    .amount {
      padding-left: calc(var(--gap) * 20);
      position: relative;
      &::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        width: 1px;
        background: var(--g5);
        left: calc(var(--gap) * 10);;
      }
    }
  }
}
</style>